@if (viewVisible) {
  <lfw-form-view-toolbar>
    <ng-container toolbar-left>
      <lfw-toolbar-text text="{{ caption }}" />
    </ng-container>

    <ng-container toolbar-center>
      @if (form) {
        <lfw-sub-state-select disabled [availableStates]="form!.subStates" [(order)]="form!.order" />
      }
    </ng-container>

    <ng-container toolbar-right>
      @if (userCanEdit()) {
        <button class="mobile-only" mat-icon-button [matMenuTriggerFor]="infoMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
      } @else {
        <lfw-toolbar-button label="" icon="close" class="mobile-only" (click)="close()" />
      }

      <mat-menu class="mobile-only" #infoMenu="matMenu" yPosition="below">
        <button mat-menu-item (click)="close()">
          <mat-icon>close</mat-icon>
          <span>{{ 'DIALOGS.CLOSE' | translate }}</span>
        </button>
        <button mat-menu-item (click)="editForm()">
          <mat-icon>edit</mat-icon>
          <span>{{ 'DIALOGS.EDIT' | translate }}</span>
        </button>
      </mat-menu>

      @if (userCanEdit()) {
        <lfw-toolbar-button
          class="desktop-only"
          label="{{ 'DIALOGS.EDIT' | translate }}"
          (click)="editForm()"
          icon="edit" />
        <lfw-toolbar-divider class="desktop-only" />
      }
      <lfw-toolbar-button
        class="desktop-only"
        label="{{ 'DIALOGS.CLOSE' | translate }}"
        icon="close"
        (click)="close()" />
    </ng-container>
  </lfw-form-view-toolbar>

  @if (form) {
    <lfe-liveforms-editor #editor [form]="form" [userInfo]="user" [settings]="editorSettings" [disabled]="true" />
  }
}
